// extracted by mini-css-extract-plugin
module.exports = {"row":"_125UQN4T flex col-12 md-col-7 mx-auto clearfix","graphic":"_2rF8DN8b left","copy":"_3cYLWOIt left","icon":"h4B7e0jz","link":"_18KRhqZQ"};